import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import { useSortManager } from '@/src/hooks/srp/sortManager'
import { Box, Typography } from '@mui/material'

const SortTabsDesktop = () => {
    const { sortOptions, handleSortSelect } = useSortManager()
    return (
        <Box
            sx={{
                borderRadius: 1.5,
                border: 1,
                borderColor: 'grey.200',
                overflow: 'hidden',
                boxShadow: 'none',
                width: '100%'
            }}
        >
            <Box sx={{ display: 'flex' }}>
                {sortOptions.map((option, index) => (
                    <ErrorBoundaryWrapper
                        identifier={`sortTab-${option.id}-desktop-srp`}
                        fallback={null}
                        key={option.id}
                    >
                        <Box
                            onClick={() => handleSortSelect?.(option.sortKey)}
                            sx={{
                                flex: 1,
                                ...(index < sortOptions.length - 1 && {
                                    borderRight: 1,
                                    borderColor: 'grey.200'
                                }),
                                p: 0.5,
                                textAlign: 'center',
                                cursor: 'pointer',
                                ...(option.isActive
                                    ? {
                                        bgcolor: 'primary.A100',
                                        borderBottom: 2,
                                        borderBottomColor: 'primary.main',
                                    }
                                    : {
                                        bgcolor: '#fff',
                                        '&:hover': {
                                            bgcolor: 'grey.50'
                                        }
                                    })
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{
                                    fontSize: '0.875rem',
                                    fontWeight: 500,
                                    color: '#333333',
                                    display: 'block',
                                    mb: 0.25
                                }}
                            >
                                {option.label}
                            </Typography>
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: '0.875rem',
                                    fontWeight: 500,
                                    color: '#66797F'
                                }}
                            >
                                {option.priceAndDuration}
                            </Typography>
                        </Box>
                    </ErrorBoundaryWrapper>
                ))}
            </Box>
        </Box>
    )
}

export default SortTabsDesktop
